module.exports = __webpack_public_path__ + "front/img/b41.9a868170.jpg";